export default "/images/close-icon-big.png?3faa31586ecd265deab04ce24a90048f";